

import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs/Rx';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';
import { Store } from '@ngrx/store';

import { getExperience } from '../../store/store';
import { SearchThresholdService } from './../../services/search-threshold.service';
import { HideBannerAction } from './../../store/actions/actions';
import { Experience } from './../../models/experience';
import { SearchResult, CategoryTotal } from './../../models/search-result';

import * as fromRoot from '@api/store/app-store';
import * as ui from './../../store/actions/actions';

@Component({
    template: require('./search-results-list.component.html')
})
 
export class SearchResultsListComponent {
    loading: boolean = true;
    searchPhrase: string;
    searchResults: Array<any> = [];
    categoriesTotals: Array<CategoryTotal> = [];
    totalItems: number;
    pageSize: number = 10;
    activePage: number = 1;

    private experiences: Experience[];    
    private categories;

    constructor(private store: Store<any>, private route: ActivatedRoute, private searchService: SearchThresholdService) {
        this.store.dispatch(new ui.HideBannerAction());
        this.store.dispatch(new ui.HideContextNavAction());

        const expsLoaded = new Subject();

        route.params.subscribe(params => {
            this.searchPhrase = params['searchPhrase'];
            this.loading = true;

            let search = this.searchService.search(this.searchPhrase, this.pageSize, 0);

            if (!this.experiences) {
                expsLoaded.switchMap(() => search).subscribe(result => this.showResults(result));
            } else {
                search.subscribe(result => this.showResults(result));
            }
        });

        this.store.select(getExperience).subscribe((experiences) => {
            if (experiences) {
                this.experiences = experiences;
                expsLoaded.next();
            }
        });
    }

    private showResults(result: SearchResult): void {
        this.loading = false;

        this.searchResults = result.items.map(element => {
            let experience = this.experiences.filter(exp => exp.id === element.applicationId)[0];

            return {
                moduleUrl: experience.moduleUrl,
                componentId: element.component,
                payload: element
            };
        });

        this.categoriesTotals = result.categoriesTotals.filter(cat => cat.count > 0);
        this.totalItems = result.total;
    }

    onFilterChange(categoryFilter: Array<CategoryTotal>) {
        this.loading = true;

        this.activePage = 1;
        this.categories = categoryFilter.filter(cat => cat.checked === true).map(c => c.name);
        let search = this.searchService.search(this.searchPhrase, this.pageSize, 0, this.categories);

        search.subscribe(result => this.showResults(result));
    }
    
    onPageChange(newPageNumber: number) {
        this.loading = true;

        this.activePage = newPageNumber;
        let skip = (this.activePage - 1) * this.pageSize;
        let search = this.searchService.search(this.searchPhrase, this.pageSize, skip, this.categories);

        search.subscribe(result => this.showResults(result));
    }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/angular-router-loader/src!./src/app/threshold/components/search/search-results-list.component.ts